import SingleSelectFilter from "./SingleSelectFilter";
export default SingleSelectFilter;
